/* eslint-disable no-use-before-define */
import * as tmsEventsApi from '../api/tmsEventsApi';
import * as checkoutEventRegistrationApi from '../api/checkoutEventRegistrationApi';
import * as tmsEventsNextAvailableApi from '../api/tmsEventsNextAvailableApi';
import * as eventsApi from '../api/eventsApi';
import * as clubsApi from '../api/clubsApi';
import * as api from '../api';
import * as uploadApi from '../api/uploadApi';
import { acceptanceRankingValues, divisionFormatTypeIds, drawCategoryTypeIds, eventFormatTypeIds, sportTypeIds } from '../utils/eventConstants';
import { responseStatusTypes, sortParamTypes } from '../utils/constants';
import { isTeamTennisClubV2 } from '../utils/clubs';
import { getAdultTeamTennisEvents } from './club-actions';
import { convertPlayerTOSearchPlayerObject, drawStandingsEnabledV2, hasPlayerInvitationAndRegDateOpen, isDoublesDivision, isOrganizer, getPlayers as getPlayersListFromMatchPosition, allStandingsEnabled, partnerDetailsToSearchPlayer } from '../utils/events';
import { buildUserParallelRequests } from '../utils/userParallelRequests';
import { findMatchAcrossSlices, findMatchInSlices } from '../utils/postScoreCascade';
import { buildSyntheticMatchPayload, buildSyntheticClearPayload } from '../utils/postScoreSynth';

import {
    EVENT_PROFILE_REINIT,
    EVENT_PROFILE_GET_EVENT,
    EVENT_PROFILE_GET_EVENT_SUCCESS,
    EVENT_PROFILE_GET_EVENT_FAILURE,
    EVENT_PROFILE_REFRESH_EVENT_SUCCESS,
    EVENT_PROFILE_GET_DRAWS,
    EVENT_PROFILE_GET_DRAWS_SUCCESS,
    EVENT_PROFILE_GET_DRAWS_FAILURE,
    EVENT_PROFILE_GET_PLAYERS,
    EVENT_PROFILE_GET_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_PLAYERS_FAILURE,
    EVENT_PROFILE_GET_ELIGIBLE_PLAYERS,
    EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_FAILURE,
    EVENT_PROFILE_DELETE_ELIGIBLE_PLAYER_SUCCESS,
    EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES,
    EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_SUCCESS,
    EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_FAILURE,
    EVENT_PROFILE_DELETE_PRE_REGISTRATION_INVITE_SUCCESS,
    EVENT_PROFILE_GET_PRE_REG_FILTERS,
    EVENT_PROFILE_GET_PRE_REG_FILTERS_SUCCESS,
    EVENT_PROFILE_GET_PRE_REG_FILTERS_FAILURE,
    EVENT_PROFILE_GET_WITHDRAWN_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_TEAMS,
    EVENT_PROFILE_GET_TEAMS_SUCCESS,
    EVENT_PROFILE_GET_TEAMS_FAILURE,
    EVENT_PROFILE_GET_DRAW,
    EVENT_PROFILE_GET_DRAW_SUCCESS,
    EVENT_PROFILE_GET_DRAW_FAILURE,
    EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_SUCCESS,
    EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_FAILURE,
    EVENT_PROFILE_LIVE_SCORE_UPDATE,
    EVENT_PROFILE_EVENT_TEAM_STANDINGS_SUCCESS,
    EVENT_PROFILE_GET_LOCATIONS,
    EVENT_PROFILE_GET_LOCATIONS_SUCCESS,
    EVENT_PROFILE_GET_LOCATIONS_FAILURE,
    EVENT_PROFILE_FETCH_MATCH_SHEET,
    EVENT_PROFILE_FETCH_MATCH_SHEET_SUCCESS,
    EVENT_PROFILE_FETCH_MATCH_SHEET_FAILURE,
    EVENT_PROFILE_GET_MATCH_SHEET_MATCHES_SUCCESS,
    EVENT_PROFILE_GET_OFFICIALS,
    EVENT_PROFILE_GET_OFFICIALS_SUCCESS,
    EVENT_PROFILE_GET_OFFICIALS_FAILURE,
    EVENT_PROFILE_ORDER_PLAYERS,
    EVENT_PROFILE_GET_DRAW_OFFICIALS,
    EVENT_PROFILE_GET_DRAW_OFFICIALS_SUCCESS,
    EVENT_PROFILE_GET_DRAW_OFFICIALS_FAILURE,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST_SUCCESS,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST_FAILURE,
    EVENT_PROFILE_SHOW_ADMIN_SPLASH,
    EVENT_PROFILE_HIDE_ADMIN_SPLASH,
    EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG,
    EVENT_PROFILE_SET_OVERVIEW_TAB_STATE,
    EVENT_PROFILE_SET_DRAWS_TAB_STATE,
    EVENT_PROFILE_SET_PLAYERS_TAB_STATE,
    EVENT_PROFILE_GET_ATTACHMENTS,
    EVENT_PROFILE_GET_ATTACHMENTS_SUCCESS,
    EVENT_PROFILE_GET_ATTACHMENTS_FAILURE,
    EVENT_PROFILE_DRAW_CONTACTS_SUCCESS,
    EVENT_PROFILE_GET_REG_PAYMENTS,
    EVENT_PROFILE_GET_REG_PAYMENTS_SUCCESS,
    EVENT_PROFILE_GET_REG_PAYMENTS_FAILURE,
    EVENT_PROFILE_GET_META_SUCCESS,
    EVENT_PROFILE_EDIT_TEAM_STANDING_SUCCESS,
    EVENT_PROFILE_DELETE_TEAM_STANDING_SUCCESS,
    EVENT_PROFILE_SET_PLAYER_WILDCARD_SUCCESS,
    EVENT_PROFILE_GET_EVENT_REGIONS,
    EVENT_PROFILE_GET_EVENT_REGIONS_SUCCESS,
    EVENT_PROFILE_MOVE_PLAYER_TO_ROUND_SUCCESS,
    EVENT_PROFILE_CROP_BANNER_PHOTO_SUCCESS,
    EVENT_PROFILE_REG_ADD_TEAMMATE,
    EVENT_PROFILE_GET_MATCH_SUCCESS,
    EVENT_PROFILE_PUBLISH_SUCCESS,
    EVENT_PROFILE_UNPUBLISH_SUCCESS,
    EVENT_PROFILE_DELETE_FAILURE,
    EVENT_PROFILE_HIDE_DELETE_FAILED_POPUP,
    EVENT_PROFILE_REMOVE_BANNER_PHOTO_SUCCESS,
    EVENT_PROFILE_GET_DRAW_STATS,
    EVENT_PROFILE_GET_DRAW_STATS_FAILURE,
    EVENT_PROFILE_GET_DRAW_STATS_SUCCESS,
    EVENT_PROFILE_SET_REG_CONFIRMATION,
    EVENT_PROFILE_GET_INVITES,
    EVENT_PROFILE_GET_INVITES_SUCCESS,
    EVENT_PROFILE_GET_INVITES_FAILURE,
    EVENT_PROFILE_REG_CLEAR_TEAMMATES,
    EVENT_PROFILE_SET_REG_DIVISION_ID,
    EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS,
    EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS_FAILURE,
    EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS_SUCCESS,
    EVENT_PROFILE_SET_DIVISIONS_BASED_DATE,
    EVENT_PROFILE_RESET_DIVISIONS_BASED_DATE,
    EVENT_PROFILE_GET_REGISTRATIONS,
    EVENT_PROFILE_GET_REGISTRATIONS_SUCCESS,
    EVENT_PROFILE_GET_REGISTRATIONS_FAILURE,
    EVENT_PROFILE_GET_FACILITIES,
    EVENT_PROFILE_GET_FACILITIES_SUCCESS,
    EVENT_PROFILE_GET_FACILITIES_FAILURE,
    EVENT_PROFILE_CREATE_PRINT_CONFIG,
    EVENT_PROFILE_CREATE_PRINT_CONFIG_SUCCESS,
    EVENT_PROFILE_CREATE_PRINT_CONFIG_FAILURE,
    EVENT_PROFILE_PRINT_TEST_PAGE,
    EVENT_PROFILE_PRINT_TEST_PAGE_SUCCESS,
    EVENT_PROFILE_PRINT_TEST_PAGE_FAILURE,
    EVENT_PROFILE_SET_DECLINE_INVITATION_DATA,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_SUCCESS,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_FAILURE,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_SUCCESS,
    EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_FAILURE,
    EVENT_PROFILE_GET_MATCHSHEET_DATA,
    EVENT_PROFILE_GET_MATCHSHEET_DATA_SUCCESS,
    EVENT_PROFILE_GET_MATCHSHEET_DATA_FAILURE,
    EVENT_PROFILE_GET_DRAW_ALL_STATS,
    EVENT_PROFILE_GET_DRAW_ALL_STATS_SUCCESS,
    EVENT_PROFILE_GET_DRAW_ALL_STATS_FAILURE,
    EVENT_PROFILE_GET_MEDALPRINT_DATA,
    EVENT_PROFILE_GET_MEDALPRINT_DATA_SUCCESS,
    EVENT_PROFILE_GET_MEDALPRINT_DATA_FAILURE,
    EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS,
    EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_SUCCESS,
    EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_FAILURE,
    EVENT_PROFILE_SEND_EVENT_INVITE,
    EVENT_PROFILE_SEND_EVENT_INVITE_FAILURE,
    EVENT_PROFILE_SEND_EVENT_INVITE_SUCCESS,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_FAILURE,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_SUCCESS,
    EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_RESET,
    EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS,
    EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_SUCCESS,
    EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_FAILURE,
    EVENT_PROFILE_ADD_CHANGE_PARTNER_UPDATE,
    EVENT_PROFILE_RESET_REGISTERED_DOUBLES_DIVISIONS,
    EVENT_PROFILE_GET_PRE_REG_STATS,
    EVENT_PROFILE_GET_PRE_REG_STATS_SUCCESS,
    EVENT_PROFILE_GET_PRE_REG_STATS_FAILURE,
    EVENT_PROFILE_REG_CLEAR_PRE_REG_INVITE,
    EVENT_PROFILE_GET_ACCEPTANCE_LIST_DATA_CLEAR,
    EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS,
    EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_SUCCESS,
    EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_FAILURE,
    EVENT_PROFILE_OOP_MATCH_REFRESH_SUCCESS,
    EVENT_PROFILE_FETCH_MATCH_SHEET_V2,
    EVENT_PROFILE_FETCH_MATCH_SHEET_V2_SUCCESS,
    EVENT_PROFILE_FETCH_MATCH_SHEET_V2_FAILURE,
    EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION,
    EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_SUCCESS,
    EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_FAILURE,
    EVENT_PROFILE_SORT_ATTACHMENTS,
    EVENT_PROFILE_SORT_ATTACHMENTS_FAILURE,
    EVENT_PROFILE_GET_DIVISION_COUNTS,
    EVENT_PROFILE_GET_DIVISION_COUNTS_SUCCESS,
    EVENT_PROFILE_GET_DIVISION_COUNTS_FAILURE,
} from './actionTypes/event-profile-action-types';
import { getUpdatedChildDraws, getUpdatedMatchObject } from '../utils/nextAvailable';
import { createTypeByIdDict, updateCategoryTypesName } from '../utils/formatting';
import { getActiveFacilitiesAndCourts } from '../utils/courtSchedular';
import { showErrorPopup, showSuccessToast, showInfoToast } from './notification-actions';
import { NOTIFICATIONS_SHOW_INFO_TOAST, NOTIFICATIONS_SHOW_SUCCESS_TOAST } from './actionTypes/notification-action-types';

// Track polling per eventId to avoid duplicates
const recurringPollingMap = {};

export const initState = () => async (dispatch) => {
    dispatch({ type: EVENT_PROFILE_REINIT });
};

export const getEvent = (eventId, adminSplash, includeUnpublishedMatchSheet = false) => async (dispatch, getState, { mainApi }) => {
    const showSplash = () => dispatch({ type: 'SPLASH_SHOW' });
    const hideSplash = () => dispatch({ type: 'SPLASH_HIDE' });
    const handleEventFailure = (res) => {
        const errorData = {
            message: res.data,
            displayMessage: res.data?.DisplayMessage,
            statusCode: res.data?.statusCode || null,
            redirectUrl: res.data?.clubId ? `/clubs/${res.data.clubId}` : '/',
            eventId,
        };
        dispatch({ type: EVENT_PROFILE_GET_EVENT_FAILURE, payload: errorData });
        hideSplash();
    };

    dispatch({ type: EVENT_PROFILE_GET_EVENT });
    showSplash();

    try {
        const { user } = getState().auth;

        const res = await tmsEventsApi.getEventV2(mainApi, { eventId });

        if (res.data.error) {
            handleEventFailure(res);
            return;
        }

        dispatch({
            type: EVENT_PROFILE_GET_EVENT_SUCCESS,
            payload: res.data,
        });

        const { scheduleTypeId, eventTypeId, eventTours, isRecurringEvent, hasRecurringSeries } = res.data;

        const canViewUnpublishedMatchSheet = includeUnpublishedMatchSheet && isOrganizer(res.data);

        const parallelRequests = user
            ? [
                ...buildUserParallelRequests(
                    { scheduleTypeId, eventTypeId, eventTours, isRecurringEvent, hasRecurringSeries, includeUnpublishedMatchSheet: canViewUnpublishedMatchSheet },
                    eventId,
                    dispatch,
                    {
                        getOrderOfPlaySchedule,
                        getMatchSheetV2,
                        getEventTeamStandings,
                        getEventRegions,
                        getDraws,
                        getEventInvites,
                        getRegistrations,
                        getEventLocations,
                        getEventOfficials,
                        getAllWeatherNotifications,
                        getUpcomingRecurringEvents,
                        getCurrentMemberRegistration,
                    },
                ),
            ]
            : [];

        await Promise.all(parallelRequests);

        hideSplash();

        if (adminSplash) {
            dispatch(showAdminSplash(adminSplash));
        }
    } catch (error) {
        const data = error.response ? error.response.data : null;
        const redirectUrl = data?.clubId ? `/clubs/${data.clubId}` : '/';
        const errorData = {
            message: data,
            displayMessage: data?.DisplayMessage,
            statusCode: error?.response?.status,
            redirectUrl,
            eventId,
        };

        dispatch({
            type: EVENT_PROFILE_GET_EVENT_FAILURE,
            payload: errorData,
        });
        hideSplash();
    }
};

export const getDraws = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_DRAWS });
    try {
        const res = await tmsEventsApi.getDrawEditDraws(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_DRAWS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_DRAWS_FAILURE });
        throw error;
    }
};

export const refreshEventData = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getEventV2(mainApi, { eventId });
        if (res.data && !res.data.error) {
            dispatch({ type: EVENT_PROFILE_REFRESH_EVENT_SUCCESS, payload: res.data });
        }
    } catch (error) {
        // Silent failure — keep existing event.data so the UI doesn't blank.
    }
};

export const refreshEventParticipantData = (eventId, options = {}) => async (dispatch, getState) => {
    if (!eventId) {
        return;
    }
    const { divisionIds = [] } = options;
    const state = getState();
    const { auth } = state;
    const { event, acceptance } = state.eventProfile;
    const isAdmin = !!(auth.user && event.data && isOrganizer(event.data));

    const pending = [
        dispatch(refreshEventData(eventId)),
        dispatch(getPlayersV3(eventId)),
    ];

    if (isAdmin) {
        pending.push(dispatch(getWithdrawnPlayers(eventId)));
    }

    divisionIds.forEach(divisionId => {
        if (divisionId && acceptance?.[divisionId]?.loaded) {
            pending.push(dispatch(getDivisionAcceptanceList({ eventId, divisionId })));
        }
    });

    if (auth.user) {
        pending.push(dispatch(getCurrentMemberRegistration(eventId)));
    }

    await Promise.all(pending);
};

export const getPlayersV3 = (eventId, updateCurrentMember = false) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_PLAYERS });
        const res = await tmsEventsApi.getAllPlayers(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_PLAYERS_SUCCESS, payload: res.data });

        dispatch(setTeamMatesForEventDivisionsRegistered(eventId, res.data?.players, updateCurrentMember));

        // load teams after players success (to populate teams with players data)
        dispatch(getTeams(eventId));
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_PLAYERS_FAILURE });
        throw error;
    }
};

export const getRegistrations = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_REGISTRATIONS });
    try {
        const res = await tmsEventsApi.getRegistrations(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_REGISTRATIONS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_REGISTRATIONS_FAILURE });
        throw error;
    }
};

export const setTeamMatesForEventDivisionsRegistered = (eventId, players = [], updateCurrentMember = false) => async (dispatch, getState) => {
    const { eventProfile, auth } = getState();
    const { event } = eventProfile;

    const eventData = event?.data || {};
    const { currentMember, eventDivisions } = eventData;
    let currentMemberRegDivisions = currentMember?.registeredDivisions || [];

    if (updateCurrentMember) {
        const { currentMember } = eventData;
        const { id } = auth?.user || {};

        const currentMemberPlayer = players.find((player) => {
            return player.memberId === id;
        });

        if (currentMemberPlayer) {
            currentMemberRegDivisions = currentMemberPlayer.divisions;
        } else {
            currentMemberRegDivisions = [];
        }

        dispatch({
            type: EVENT_PROFILE_GET_EVENT_SUCCESS,
            payload: {
                ...eventData,
                currentMember: {
                    ...currentMember,
                    registeredDivisions: currentMemberRegDivisions,
                },
            },
        });
    }

    (currentMemberRegDivisions || []).forEach((invitedDivision) => {
        const invitedPartnerId = invitedDivision.partners[0];
        const division = eventDivisions.find((div) => {
            return div.id === invitedDivision.id;
        });

        if (division && isDoublesDivision(division)) {
            const invitedPlayer = players.find((player) => {
                return player.memberId === invitedPartnerId;
            });

            if (invitedPlayer) {
                dispatch(addTeammateToDivison({
                    divisionId: invitedDivision.id,
                    player2: convertPlayerTOSearchPlayerObject(invitedPlayer),
                    isInvited: hasPlayerInvitationAndRegDateOpen(invitedDivision, division),
                }));
            }
        }
    });
};

export const getWithdrawnPlayers = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.getWithdrawnPlayers(mainApi, { eventId });
    dispatch({ type: EVENT_PROFILE_GET_WITHDRAWN_PLAYERS_SUCCESS, payload: res.data });
};
export const getTeams = (eventId) => async (dispatch, getState, { mainApi }) => {
    const { currentDraw, event } = getState().drawEdit;
    try {
        dispatch({ type: EVENT_PROFILE_GET_TEAMS });
        const res = await tmsEventsApi.getDrawEditTeams(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_TEAMS_SUCCESS, payload: res.data });
        if (currentDraw.data) {
            const isSingles = currentDraw.data.formatTypeId === eventFormatTypeIds.SINGLES;
            const isPickleballEvent = event.data?.sportTypeId === sportTypeIds.PICKLEBALL;
            let sortParam = isSingles ? sortParamTypes.SINGLESUTR : sortParamTypes.DOUBLESUTR;
            if (isPickleballEvent) {
                sortParam = isSingles ? sortParamTypes.SINGLESPKB : sortParamTypes.DOUBLESPKB;
            }
            dispatch(orderPlayers({
                sortParam,
                sortType: 'desc',
                formatTypeId: currentDraw.data.formatTypeId,
                utrTypeId: event.data.utrTypeId,
            }));
        }
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_TEAMS_FAILURE });
        throw error;
    }
};
export const getDraw = ({ eventId, drawId, isChildDraw, setAsCurrentDraw, dontAutoLoadFirstChildDraw }) => async (dispatch, getState, { mainApi }) => {
    try {
        const { draws } = getState().eventProfile;
        dispatch({ type: EVENT_PROFILE_GET_DRAW, payload: { isChildDraw, drawId } });
        const res = await tmsEventsApi.getEventProfileDraw(mainApi, { eventId, drawId });
        dispatch({
            type: EVENT_PROFILE_GET_DRAW_SUCCESS,
            payload: {
                draw: {
                    ...res.data,
                    // add playoff data derived from child draws, to single draw GET responses
                    ...({ hasPlayoff: draws?.drawsDict?.[drawId]?.hasPlayoff || false }),
                },
                isChildDraw,
                setAsCurrentDraw,
            },
        });
        if ((isChildDraw || setAsCurrentDraw) && res.data.categoryTypeId !== drawCategoryTypeIds.GROUPED) {
            dispatch(getDrawOfficials(eventId, drawId));
            dispatch(getDrawPlayerContactInfo(eventId, drawId));
            const standingsEnabled = res.data.eliminationTypeId && drawStandingsEnabledV2(res.data.eliminationTypeId);
            if (standingsEnabled) {
                dispatch(getDrawStats(eventId, drawId));
            }
        }
        // if a grouped draw's parent draw is loaded, store it as parentDraw, and
        // automatically load the first child draw as currentDraw
        if (!isChildDraw && res.data.categoryTypeId === drawCategoryTypeIds.GROUPED && !dontAutoLoadFirstChildDraw && draws.data) {
            const firstChildDraw = draws.data?.find(draw => draw.id === drawId).childDraws[0];
            if (firstChildDraw) {
                dispatch(getDraw({ eventId, drawId: firstChildDraw.id, isChildDraw: true }));
            }
        }
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_DRAW_FAILURE, payload: { isChildDraw } });
        throw error;
    }
};

export const getOrderOfPlaySchedule = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getOrderOfPlaySchedule(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_ORDER_OF_PLAY_SCHEDULE_FAILURE });
    }
};

export const getEventTeamStandings = (eventId) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.getTeamStandings(mainApi, eventId);

    if (response.status === responseStatusTypes.OK) {
        dispatch({
            type: EVENT_PROFILE_EVENT_TEAM_STANDINGS_SUCCESS,
            payload: response.data.standings,
        });
    }
};

export const getEventLocations = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_LOCATIONS });
        const res = await tmsEventsApi.getEventLocations(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_LOCATIONS_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error loading locations.',
                error: data.error,
            }));
        } else {
            dispatch({ type: EVENT_PROFILE_GET_LOCATIONS_SUCCESS, data });
        }
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_LOCATIONS_FAILURE,
        });
    }
};

export const getMatchSheet = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_FETCH_MATCH_SHEET });
        const res = await tmsEventsApi.getMatchSheet(mainApi, eventId);
        const { data } = res;
        dispatch({ type: EVENT_PROFILE_FETCH_MATCH_SHEET_SUCCESS, data: data.matches });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_FETCH_MATCH_SHEET_FAILURE });
    }
};

export const getMatchSheetMatches = (eventId) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.getMatchSheetMatches(mainApi, { eventId });
    dispatch({ type: EVENT_PROFILE_GET_MATCH_SHEET_MATCHES_SUCCESS, payload: res.data });
};

export const getMatchSheetV2 = (eventId, includeUnpublished = false) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_FETCH_MATCH_SHEET_V2 });
        const res = await tmsEventsApi.getMatchSheetV2(mainApi, { eventId, includeUnpublished });
        dispatch({ type: EVENT_PROFILE_FETCH_MATCH_SHEET_V2_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_FETCH_MATCH_SHEET_V2_FAILURE });
    }
};

export const getCurrentMemberRegistration = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION });
        const res = await tmsEventsApi.getCurrentMemberRegistration(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_SUCCESS, payload: res.data });
        dispatch(hydrateInvitedPartnersFromCurrentMember(res.data));
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_FETCH_CURRENT_MEMBER_REGISTRATION_FAILURE });
    }
};

export const hydrateInvitedPartnersFromCurrentMember = (currentMemberRegistration) => (dispatch, getState) => {
    const eventDivisions = getState().eventProfile.event.data?.eventDivisions || [];
    const registeredDivisions = currentMemberRegistration?.registeredDivisions || [];
    registeredDivisions.forEach((regDiv) => {
        if (!regDiv.partner) {
            return;
        }
        const eventDivision = eventDivisions.find(d => d.id === regDiv.id);
        if (!eventDivision || !isDoublesDivision(eventDivision)) {
            return;
        }
        dispatch(addTeammateToDivison({
            divisionId: regDiv.id,
            player2: partnerDetailsToSearchPlayer(regDiv.partner),
            isInvited: hasPlayerInvitationAndRegDateOpen(regDiv, eventDivision),
        }));
    });
};

// Unauth endpoint for MatchSheet Data
export const getMatchSheetData = ({ eventId, drawId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_MATCHSHEET_DATA });

    try {
        const res = await tmsEventsApi.getMatchSheetData(mainApi, { eventId, drawId });
        dispatch({ type: EVENT_PROFILE_GET_MATCHSHEET_DATA_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_MATCHSHEET_DATA_FAILURE,
            payload: error,
        });
        throw error;
    }
};

export const getDrawAllStats = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_DRAW_ALL_STATS });

    try {
        const res = await tmsEventsApi.getDrawAllStats(mainApi, { eventId, drawId });
        dispatch({ type: EVENT_PROFILE_GET_DRAW_ALL_STATS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_DRAW_ALL_STATS_FAILURE,
            payload: error,
        });
        throw error;
    }
};

export const getEventOfficials = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_OFFICIALS });
        const res = await tmsEventsApi.getEventOfficials(mainApi, eventId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_OFFICIALS_FAILURE });
        } else {
            dispatch({ type: EVENT_PROFILE_GET_OFFICIALS_SUCCESS, payload: data });
        }
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_OFFICIALS_FAILURE,
        });
    }
};

export const orderPlayers = (payload) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_ORDER_PLAYERS,
        payload,
    });
};

export const getDrawOfficials = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_DRAW_OFFICIALS });
        const res = await tmsEventsApi.getDrawOfficials(mainApi, eventId, drawId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_DRAW_OFFICIALS_FAILURE });
        } else {
            dispatch({
                type: EVENT_PROFILE_GET_DRAW_OFFICIALS_SUCCESS,
                payload: { drawId, eventId, data },
            });
        }
    } catch (err) {
        dispatch({ type: EVENT_PROFILE_GET_DRAW_OFFICIALS_FAILURE, error: err });
    }
};

export const getDrawStats = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_DRAW_STATS, drawId });
        const res = await tmsEventsApi.getDrawStats(mainApi, { eventId, drawId });
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_DRAW_STATS_FAILURE });
        } else {
            dispatch({
                type: EVENT_PROFILE_GET_DRAW_STATS_SUCCESS,
                payload: data,
            });
        }
    } catch (err) {
        dispatch({ type: EVENT_PROFILE_GET_DRAW_STATS_FAILURE, error: err });
    }
};

export const clearAcceptanceListData = () => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_GET_ACCEPTANCE_LIST_DATA_CLEAR });
};

export const getDivisionAcceptanceList = ({ eventId, divisionId }) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_ACCEPTANCE_LIST, divisionId });
        const res = await tmsEventsApi.getDivisionAcceptanceListV2(mainApi, { eventId, divisionId });
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_ACCEPTANCE_LIST_FAILURE, divisionId });
        } else if (data) {
            dispatch({ type: EVENT_PROFILE_GET_ACCEPTANCE_LIST_SUCCESS, data, divisionId });
        } else {
            dispatch({ type: EVENT_PROFILE_GET_ACCEPTANCE_LIST_FAILURE, divisionId });
        }
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_ACCEPTANCE_LIST_FAILURE, divisionId, error });
    }
};

export const showAdminSplash = (message, timeout) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_SHOW_ADMIN_SPLASH,
        message,
    });
    setTimeout(() => {
        dispatch(hideAdminSplash());
    }, timeout || 3000);
};

export const hideAdminSplash = () => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_HIDE_ADMIN_SPLASH,
    });
};

export const setJustPublishedFlag = (bool) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_SET_JUST_PUBLISHED_FLAG,
        payload: bool,
    });
};

export const setOverviewTabState = (overviewTabState) => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_SET_OVERVIEW_TAB_STATE, payload: { overviewTabState } });
};

export const setDrawsTabState = (drawsTabState) => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_SET_DRAWS_TAB_STATE, payload: { drawsTabState } });
};

export const setPlayersTabState = (playersTabState) => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_SET_PLAYERS_TAB_STATE, payload: { playersTabState } });
};

export const getEventAttachments = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_ATTACHMENTS });
        const result = await eventsApi.getEventAttachments(mainApi, eventId);
        const { data } = result;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_ATTACHMENTS_FAILURE });
        } else {
            dispatch({ type: EVENT_PROFILE_GET_ATTACHMENTS_SUCCESS, data });
        }
    } catch (err) {
        dispatch({ type: EVENT_PROFILE_GET_ATTACHMENTS_FAILURE, error: err });
    }
};

export const uploadEventAttachment = ({ eventId, formData }) => async (dispatch, getState, { mainApi }) => {
    try {
        const result = await eventsApi.uploadEventAttachment(mainApi, eventId, formData);
        const { data } = result;
        if (data.error) {
            dispatch(showErrorPopup({
                message: 'Error uploading attachment',
                error: data.error,
            }));
        } else {
            dispatch(showSuccessToast({ message: 'Attachment uploaded' }));
            dispatch(getEventAttachments(eventId));
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading attachment',
            error: err,
        }));
    }
};

export const deleteEventAttachment = (eventId, fileId) => async (dispatch, getState, { mainApi }) => {
    try {
        await eventsApi.deleteEventAttachment(mainApi, eventId, fileId);
        dispatch(getEventAttachments(eventId));
        dispatch(showSuccessToast({ message: 'Attachment deleted' }));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error deleting attachment',
            error,
        }));
    }
};

export const sortEventAttachments = (eventId, reorderedAttachments) => async (dispatch, getState, { mainApi }) => {
    const previousAttachments = getState().eventProfile.attachments;
    const payload = reorderedAttachments.map((attachment, index) => ({
        ...attachment,
        displayOrder: index + 1,
    }));
    try {
        dispatch({ type: EVENT_PROFILE_SORT_ATTACHMENTS, payload });
        const items = payload.map(({ fileId, displayOrder }) => ({ fileId, displayOrder }));
        await eventsApi.sortEventAttachments(mainApi, eventId, items);
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_SORT_ATTACHMENTS_FAILURE,
            previousAttachments,
        });
        dispatch(showErrorPopup({
            message: 'Error sorting attachments',
            error,
        }));
    }
};

export const getDrawPlayerContactInfo = (eventId, drawId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.fetchDrawPlayersContactInfo(mainApi, eventId, drawId);
        if (res.status === 200) {
            dispatch({
                type: EVENT_PROFILE_DRAW_CONTACTS_SUCCESS,
                payload: res.data,
            });
        }
    } catch (error) {
        // Failed to fetch draw player contact info
    }
};

export const sendMessageToPlayers = (message, eventId, drawId, sendCopyToOrganizer = false, memberIds) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS });
        const res = await api.sendMessage(mainApi, message, eventId, drawId, sendCopyToOrganizer, memberIds);
        if (res.data.error) {
            dispatch({
                type: EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_FAILURE,
                payload: {
                    errorMessage: res.data?.DisplayMessage,
                },
            });
        } else {
            dispatch({ type: EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_SUCCESS });
        }
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_FAILURE,
            payload: {
                errorMessage: error?.response?.data?.DisplayMessage,
            },
        });
    }
};

export const resetPlayerMessageState = () => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_SEND_MESSAGE_TO_PLAYERS_RESET });
};

export const sendInvitationToGroup = (eventId, clubId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.sendInvitationToGroup(mainApi, eventId, clubId);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error Sending Invitation',
                error: res.data.error,
            }));
        } else {
            dispatch(showSuccessToast({ message: 'Invitation Sent' }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error Sending Invitation',
            error,
        }));
    }
};
export const getRegPayments = ({ eventId, memberId }) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_REG_PAYMENTS });
        const res = await tmsEventsApi.getRegPayments(mainApi, { eventId, memberId });
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENT_PROFILE_GET_REG_PAYMENTS_FAILURE });
        } else {
            dispatch({ type: EVENT_PROFILE_GET_REG_PAYMENTS_SUCCESS, data });
        }
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_REG_PAYMENTS_FAILURE,
        });
    }
};

export const sendEventInviteToMembers = () => async (dispatch, getState, { mainApi }) => {
    const { event: { data: event } } = getState().eventProfile;
    try {
        dispatch({ type: EVENT_PROFILE_SEND_EVENT_INVITE });
        const res = await clubsApi.sendEventInviteToMembers(mainApi, event.id, event.club.id);
        const { data } = res;
        if (data?.error) {
            dispatch({ type: EVENT_PROFILE_SEND_EVENT_INVITE_FAILURE });
        } else {
            dispatch({ type: EVENT_PROFILE_SEND_EVENT_INVITE_SUCCESS, data });
        }
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_SEND_EVENT_INVITE_FAILURE,
        });
    }
};

export const getEventMetaData = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.eventMeta(mainApi, eventId);
        if (!res.data.error) {
            dispatch({
                type: EVENT_PROFILE_GET_META_SUCCESS,
                data: res.data,
            });
        }
    } catch (error) {
        // Failed to fetch event metadata
    }
};

export const addTeamStanding = (eventId, teamStanding) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.addTeamStanding(mainApi, eventId, teamStanding);

    if (response.status === 200) {
        dispatch(getEventTeamStandings(eventId));
    }
};

export const editTeamStanding = (eventId, teamStanding) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.editTeamStanding(mainApi, eventId, teamStanding);

    if (response.status === 200) {
        dispatch({
            type: EVENT_PROFILE_EDIT_TEAM_STANDING_SUCCESS,
            payload: teamStanding,
        });
    }
};

export const deleteTeamStanding = (eventId, standingId) => async (dispatch, getState, { mainApi }) => {
    const response = await tmsEventsApi.deleteTeamStanding(mainApi, eventId, standingId);

    if (response.status === 200) {
        dispatch({
            type: EVENT_PROFILE_DELETE_TEAM_STANDING_SUCCESS,
            payload: standingId,
        });
    }
};

export const setPlayerWildcard = ({ eventId, divisionId, memberId, wildcardStateId }) => async (dispatch, getState, { mainApi }) => {
    const { acceptance } = getState().eventProfile;
    try {
        const response = await tmsEventsApi.setPlayerWildcard(mainApi, { eventId, divisionId, memberId, wildcardStateId });
        if (response.status === 204) {
            dispatch({
                type: EVENT_PROFILE_SET_PLAYER_WILDCARD_SUCCESS,
                payload: { divisionId, memberId, wildcardStateId },
            });
            if (acceptance && acceptance[divisionId]?.rankingType === acceptanceRankingValues.WTA) {
                dispatch(getDivisionAcceptanceList({ eventId, divisionId }));
            }
        } else {
            dispatch(showErrorPopup({
                error: 'Error setting player wildcard',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error setting player wildcard',
            error,
        }));
    }
};

export const getEventRegions = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: EVENT_PROFILE_GET_EVENT_REGIONS,
    });

    try {
        const response = await tmsEventsApi.getEventRegions(mainApi, eventId);
        if (response.status === 200) {
            dispatch({
                type: EVENT_PROFILE_GET_EVENT_REGIONS_SUCCESS,
                payload: response.data,
            });
        } else {
            dispatch(showErrorPopup({
                error: 'Error fetching Event Regions',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching Event Regions',
            error,
        }));
    }
};

export const movePlayersToRound = (eventId, divisionId, { memberId, roundType, acceptanceType = null, isSpecialExempt = false }) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.movePlayersToRound(mainApi, eventId, divisionId, { memberId, roundType, acceptanceType, isSpecialExempt });
        if (response.status === 204) {
            dispatch({
                type: EVENT_PROFILE_MOVE_PLAYER_TO_ROUND_SUCCESS,
                payload: { divisionId, memberId, roundType, isSpecialExempt },
            });
            if (acceptanceType || isSpecialExempt) {
                dispatch(getDivisionAcceptanceList({ eventId, divisionId }));
            }
        } else {
            dispatch(showErrorPopup({
                message: 'Error moving player',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error moving player',
            error: error.response?.data?.DisplayMessage,
        }));
    }
};

export const movePlayersToMain = (eventId, divisionId, data) => async (dispatch, getState, { mainApi }) => {
    const { isDoubles, isMainFull, playerNames, memberIds } = data;
    const payload = {
        memberIds,
        increaseMainCount: !!isMainFull,
    };
    try {
        const res = await tmsEventsApi.movePlayersToMain(mainApi, eventId, divisionId, payload);
        if (res.status === 204) {
            dispatch(refreshEventParticipantData(eventId, { divisionIds: [divisionId] }));

            let message = `${isDoubles ? 'Team ' : ''}${playerNames} were moved to Main`;
            if (isMainFull) {
                message = `${message} and max ${isDoubles ? 'teams' : 'players'} was increased by 1.`;
            }

            dispatch(showSuccessToast({
                title: 'Success',
                message,
            }));
        } else {
            dispatch(showErrorPopup({
                message: `Error moving player${isDoubles ? 's' : ''}`,
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: `Error moving player${isDoubles ? 's' : ''}`,
            error: error.response?.data?.DisplayMessage,
        }));
    }
};

export const cropEventBanner = (eventId, values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await uploadApi.submitEventBannerCrop(mainApi, eventId, values);
        dispatch({
            type: EVENT_PROFILE_CROP_BANNER_PHOTO_SUCCESS,
            res,
        });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error uploading image data.',
            error: err,
        }));
        throw err;
    }
};

export const addTeammateToDivison = ({ divisionId, player2, isInvited = false }) => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_REG_ADD_TEAMMATE, payload: { divisionId, player2, isInvited } });
};

export const addChangePartnerUpdate = ({ divisionId, player2 }) => (dispatch) => {
    dispatch({ type: EVENT_PROFILE_ADD_CHANGE_PARTNER_UPDATE, payload: { divisionId, player2 } });
};

export const selfWithdrawFromEvent = (withdrawPayload, onSuccessCallback) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.selfWithdraw(mainApi, withdrawPayload);

        if (response.status === 200) {
            if (onSuccessCallback && typeof onSuccessCallback === 'function') {
                onSuccessCallback();
            }

            dispatch(getEvent(withdrawPayload.eventId));
        } else {
            dispatch(showErrorPopup({
                message: 'Error withdrawing registration',
                error: response.data,
            }));
        }
    } catch (e) {
        dispatch(showErrorPopup({
            message: 'Error withdrawing registration',
            error: e,
        }));
    }
};

export const getRestrictedDivisions = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getRestrictedDivisions(mainApi, eventId);
        if (res.status === 200) {
            return res.data;
        }
        return {};
    } catch (error) {
        // Failed to fetch restricted divisions
    }
};

const fetchMatchOnly = (matchId, drawId) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    const res = await tmsEventsApi.getEventProfileMatch(mainApi, { eventId: event.data.id, drawId, matchId });
    dispatch({ type: EVENT_PROFILE_GET_MATCH_SUCCESS, payload: res.data });
    return res.data;
};

// Cascades one level only: refetches the match and its direct winner/loser output matches.
// Deeper transitive successors are not refetched — callers needing full bracket sync must dispatch separately.
export const getMatch = (matchId, drawId) => async (dispatch, getState) => {
    const { matchSheet, orderOfPlaySchedule, currentDraw } = getState().eventProfile;
    const slices = { matchSheet, orderOfPlaySchedule, currentDraw };

    const resolvedDrawId = drawId || findMatchAcrossSlices(matchId, slices).drawId || currentDraw.data?.id;
    if (!resolvedDrawId) {
        return;
    }
    const saved = await dispatch(fetchMatchOnly(matchId, resolvedDrawId));

    const cascadeFetches = [];
    if (saved.winnerOutputMatchId) {
        const { drawId: winnerDrawId } = findMatchAcrossSlices(saved.winnerOutputMatchId, slices);
        if (winnerDrawId) {
            cascadeFetches.push(dispatch(fetchMatchOnly(saved.winnerOutputMatchId, winnerDrawId)));
        }
    }
    if (saved.loserOutputMatchId) {
        const { drawId: loserDrawId } = findMatchAcrossSlices(saved.loserOutputMatchId, slices);
        if (loserDrawId) {
            cascadeFetches.push(dispatch(fetchMatchOnly(saved.loserOutputMatchId, loserDrawId)));
        }
    }

    await Promise.all(cascadeFetches);
};

export const postScore = (resultObj, drawId) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw, parentDraw, draws } = getState().eventProfile;
    const { matchId } = resultObj;
    const draw = drawId ? draws.drawsDict[drawId] : currentDraw.data;
    if (event.data.sportTypeId === sportTypeIds.PICKLEBALL || draw?.formatTypeId === divisionFormatTypeIds.DINGLES) {
        await api.postSinglePointScore(mainApi, resultObj);
    } else {
        await api.postScore(mainApi, resultObj);
    }

    const { matchSheet, orderOfPlaySchedule } = getState().eventProfile;
    const existing = findMatchInSlices(matchId, { matchSheet, orderOfPlaySchedule, currentDraw });
    if (existing) {
        dispatch({
            type: EVENT_PROFILE_GET_MATCH_SUCCESS,
            payload: buildSyntheticMatchPayload(resultObj, existing.match, existing.roundId),
        });
    }

    dispatch(getMatch(matchId, drawId)).catch(() => {
        dispatch(showInfoToast({
            title: 'Sync failed',
            message: 'Could not sync match data. Data may be out of date.',
        }));
    });

    const standingsEnabled = currentDraw.data.eliminationTypeId && drawStandingsEnabledV2(currentDraw.data.eliminationTypeId);
    if (standingsEnabled) {
        dispatch(getDrawStats(event.data.id, currentDraw.data.id));
    }
    const isAllStandingsEnabled = parentDraw.data.eliminationTypeId && allStandingsEnabled(parentDraw.data);
    if (isAllStandingsEnabled) {
        dispatch(getDrawAllStats(event.data.id, parentDraw.data?.id));
    }
};

export const clearScore = (resultObj, drawId) => async (dispatch, getState, { mainApi }) => {
    const { event, currentDraw, draws } = getState().eventProfile;
    const { id } = resultObj;
    const draw = drawId ? draws.drawsDict[drawId] : currentDraw.data;
    if (event.data.sportTypeId === sportTypeIds.PICKLEBALL || draw?.formatTypeId === divisionFormatTypeIds.DINGLES) {
        await api.clearSinglePointScore(mainApi, { matchId: id });
    } else {
        await api.clearScore(mainApi, resultObj);
    }

    const { matchSheet, orderOfPlaySchedule } = getState().eventProfile;
    const existing = findMatchInSlices(id, { matchSheet, orderOfPlaySchedule, currentDraw });
    if (existing) {
        dispatch({
            type: EVENT_PROFILE_GET_MATCH_SUCCESS,
            payload: buildSyntheticClearPayload(existing.match, existing.roundId),
        });
    }

    dispatch(getMatch(id, drawId)).catch(() => {
        dispatch(showInfoToast({
            title: 'Sync failed',
            message: 'Could not sync match data. Data may be out of date.',
        }));
    });
};

export const resetEvent = () => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    try {
        await tmsEventsApi.resetEvent(mainApi, event.data.id);
        // reload event
        dispatch(getEvent(event.data.id, 'Your event has been reset!'));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error resetting event',
            error,
        }));
    }
};

export const publishEvent = () => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Publishing',
        description: 'Please wait while we\'re publishing your event',
    });
    try {
        await tmsEventsApi.publishEvent(mainApi, event.data.id);
        dispatch({ type: EVENT_PROFILE_PUBLISH_SUCCESS, eventId: event.data.id });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showAdminSplash('Event has been published.'));
        if (isTeamTennisClubV2(event.data.club.tierTypeId)) {
            dispatch(getAdultTeamTennisEvents({ clubId: event.data.club.id }));
        }
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: err.response.data.DisplayMessage,
            error: err,
        }));
        throw err;
    }
};

export const publishRecurringEvent = (recurrentEventPublishSelections = []) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Publishing',
        description: 'Please wait while we\'re publishing your event',
    });
    try {
        const res = await tmsEventsApi.publishEvent(mainApi, event.data.id, { recurrentEventPublishSelections });
        dispatch({ type: EVENT_PROFILE_PUBLISH_SUCCESS, eventId: event.data.id });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showAdminSplash('Event has been published.'));
        if (isTeamTennisClubV2(event.data.club.tierTypeId)) {
            dispatch(getAdultTeamTennisEvents({ clubId: event.data.club.id }));
        }
        return res;
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: err?.response?.data?.DisplayMessage || 'Error publishing event.',
            error: err,
        }));
        throw err;
    }
};

export const unPublishEvent = () => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Unpublishing',
        description: 'Please wait while we\'re unpublishing your event',
    });
    try {
        await tmsEventsApi.unPublishEvent(mainApi, event.data.id);
        dispatch({ type: EVENT_PROFILE_UNPUBLISH_SUCCESS, eventId: event.data.id });
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showAdminSplash('Your event has been unpublished!'));
        if (isTeamTennisClubV2(event.data.club.tierTypeId)) {
            dispatch(getAdultTeamTennisEvents({ clubId: event.data.club.id }));
        }
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error unpublishing event.',
            error: err,
        }));
        throw err;
    }
};

export const deleteEvent = (showSplash = true) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    if (showSplash) {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
            title: 'Deleting',
            description: 'Please wait while we\'re deleting your event',
        });
    }
    const res = await tmsEventsApi.deleteEvent(mainApi, event.data.id);
    try {
        if (res?.data?.status === 'success') {
            if (showSplash) {
                dispatch({ type: 'SPLASH_HIDE' });
            }
            dispatch(showAdminSplash('Your event has been deleted!'));
            if (isTeamTennisClubV2(event.data.club.tierTypeId)) {
                dispatch(getAdultTeamTennisEvents({ clubId: event.data.club.id }));
            }
            return true;
        }
        if (showSplash) {
            dispatch({ type: 'SPLASH_HIDE' });
        }
        dispatch(showErrorPopup({
            error: 'Error deleting event',
        }));
        dispatch({ type: EVENT_PROFILE_DELETE_FAILURE });
    } catch (e) {
        if (showSplash) {
            dispatch({ type: 'SPLASH_HIDE' });
        }
        dispatch(showErrorPopup({
            message: 'Error deleting event',
            error: e,
        }));
        dispatch({ type: EVENT_PROFILE_DELETE_FAILURE });
    }
};

export const cloneEvent = () => async (dispatch, getState, { mainApi }) => {
    dispatch({
        type: 'SPLASH_SHOW_LOADING',
        title: 'Duplicating',
        description: 'Please wait while we\'re duplicating event',
    });
    const { event } = getState().eventProfile;
    try {
        const res = await tmsEventsApi.cloneEvent(mainApi, event.data.id);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error duplicating event',
                error: res.data.error,
            }));
        } else {
            return res.data;
        }
    } catch (error) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error duplicating event',
            error,
        }));
    }
};

export const showDeleteFailedPopup = () => async (dispatch) => {
    dispatch({ type: EVENT_PROFILE_DELETE_FAILURE });
};

export const closeDeleteFailedPopup = () => async (dispatch) => {
    dispatch({ type: EVENT_PROFILE_HIDE_DELETE_FAILED_POPUP });
};

export const removeBannerPhoto = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        await uploadApi.removeEventBannerPhoto(mainApi, eventId);
        dispatch({ type: EVENT_PROFILE_REMOVE_BANNER_PHOTO_SUCCESS });
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error removing event banner.',
            error: err,
        }));
        throw err;
    }
};

export const setRegConfirmation = (payload) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_SET_REG_CONFIRMATION,
        payload,
    });
};

export const setRegDivisionId = (payload) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_SET_REG_DIVISION_ID,
        payload,
    });
};
export const setSelectedDivisionsBasedOnDate = (payload) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_SET_DIVISIONS_BASED_DATE,
        payload,
    });
};
export const resetSelectedDivisionsBasedOnDate = () => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_RESET_DIVISIONS_BASED_DATE,
    });
};

export const lookupRegistrations = (eventId, memberIds, signal) => async (dispatch, getState, { mainApi }) => {
    const res = await tmsEventsApi.lookupRegistrations(mainApi, eventId, memberIds, signal);
    return res.data;
};

export const addPlayerByOrganizerV2 = (eventId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.registerPlayerByOrganizerV2(mainApi, eventId, data);
        if (res.status === 200) {
            return true;
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error registering player.',
            err,
        }));
    }
};

export const getEventInvites = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_INVITES });
        const res = await tmsEventsApi.getEventInvites(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_INVITES_SUCCESS, payload: res.data?.invites });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_INVITES_FAILURE });
        throw error;
    }
};

export const addPartner = (payload) => async (dispatch, getState, { mainApi }) => {
    const { event } = getState().eventProfile;
    const eventId = event.data.id;
    try {
        const res = await tmsEventsApi.addPartner(mainApi, { eventId, payload });
        if (res.status === 200) {
            dispatch(refreshEventParticipantData(eventId, { divisionIds: payload?.divisionId ? [payload.divisionId] : [] }));
        } else {
            dispatch(showErrorPopup({
                message: 'Error adding partner',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error adding partner',
        }));
    }
};

export const setDeclineInvitationData = (data) => (dispatch) => {
    dispatch({
        type: EVENT_PROFILE_SET_DECLINE_INVITATION_DATA,
        payload: data,
    });
};

export const declinePartnerInvitations = (eventId, divisions, showGlobalLoader) => async (dispatch, getState, { mainApi }) => {
    try {
        if (showGlobalLoader) {
            dispatch({
                type: 'SPLASH_SHOW_LOADING',
            });
        }

        const divisionParams = divisions.map((div) => {
            return {
                divisionId: div.id,
            };
        });

        await checkoutEventRegistrationApi.legacyRemovePartners(mainApi, eventId, divisionParams);

        // clear all declined invitation partners
        dispatch({ type: EVENT_PROFILE_REG_CLEAR_TEAMMATES, payload: { clearInvitedByPartnersOnly: true } });

        await dispatch(getPlayersV3(eventId, true));
        dispatch(getCurrentMemberRegistration(eventId));

        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (error) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error declining invitation',
            error,
        }));
    }
};

export const declineAdminAddedDivisions = (eventId, divisions, showGlobalLoader) => async (dispatch, getState, { mainApi }) => {
    try {
        if (showGlobalLoader) {
            dispatch({
                type: 'SPLASH_SHOW_LOADING',
            });
        }

        const divisionParams = divisions.map((div) => {
            return {
                divisionId: div.id,
            };
        });

        await checkoutEventRegistrationApi.declineAdminAddedDivisions(mainApi, eventId, divisionParams);

        // clear all declined invitation partners
        dispatch({ type: EVENT_PROFILE_REG_CLEAR_TEAMMATES, payload: { clearInvitedByPartnersOnly: true } });

        await dispatch(getPlayersV3(eventId, true));
        dispatch(getCurrentMemberRegistration(eventId));

        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (error) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error declining admin added divisions',
            error,
        }));
    }
};

export const splitDivisionTeam = (eventId, registrationGroupId, divisionId) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.splitDivisionTeam(mainApi, eventId, registrationGroupId);
        if (response.status === 204) {
            dispatch(refreshEventParticipantData(eventId, { divisionIds: divisionId ? [divisionId] : [] }));
        } else {
            dispatch(showErrorPopup({
                message: 'Error splitting team',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error splitting team',
            error: error.response?.data?.Message,
        }));
    }
};

export const removePlayers = (eventId, memberId, registrationGroupId, divisionId) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.removePlayers(mainApi, eventId, memberId, registrationGroupId);
        if (response.status === 204) {
            dispatch(refreshEventParticipantData(eventId, { divisionIds: divisionId ? [divisionId] : [] }));
        } else {
            dispatch(showErrorPopup({
                message: 'Error removing players',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error removing players',
            error: error.response?.data?.Message,
        }));
    }
};

export const getAllWeatherNotifications = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({ type: EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS });
        const response = await tmsEventsApi.getAllWeatherNotifications(mainApi, eventId);
        dispatch({ type: EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS_SUCCESS, payload: response.data.notifications });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_WEATHER_NOTIFICATIONS_FAILURE });
    }
};

export const createWeatherNotification = (eventId, notificationText) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.createWeatherNotification(mainApi, eventId, notificationText);
        if (response.status === 200) {
            await dispatch(getAllWeatherNotifications(eventId));
        } else {
            dispatch(showErrorPopup({
                error: 'Error Creating Weather Notification',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error Creating Weather Notification',
            error: error.response?.data?.DisplayMessage,
        }));
    }
};

export const updateWeatherNotification = (eventId, notificationId, notificationText) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.updateWeatherNotification(mainApi, eventId, notificationId, notificationText);
        if (response.status === 200) {
            await dispatch(getAllWeatherNotifications(eventId));
        } else {
            dispatch(showErrorPopup({
                error: 'Error Updating Weather Notification',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error Updating Weather Notification',
            error: error.response?.data?.DisplayMessage,
        }));
    }
};

export const deleteWeatherNotification = (eventId, notificationId) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.deleteWeatherNotification(mainApi, eventId, notificationId);
        if (response.status === 200) {
            await dispatch(getAllWeatherNotifications(eventId));
        } else {
            dispatch(showErrorPopup({
                message: 'Error Deleting Weather Notification',
            }));
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error Deleting Weather Notification',
            error: error.response?.data?.DisplayMessage,
        }));
    }
};

export const addEligiblePlayerIDsByOrganizer = (eventId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.addEligiblePlayersV2(mainApi, eventId, data);
        if (res.status === 200) {
            return {
                success: true,
                data: res.data,
            };
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error adding eligible players.',
            err,
        }));
    }
};

export const getEligiblePlayers = (eventId, page = 1, searchTerm = '') => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_ELIGIBLE_PLAYERS });
    try {
        const res = await tmsEventsApi.getEligiblePlayersV2(mainApi, eventId, page, searchTerm);
        dispatch({ type: EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_ELIGIBLE_PLAYERS_FAILURE });
        throw error;
    }
};

export const deleteEligiblePlayer = (eventId, eligiblePlayerId) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.removeEligiblePlayerV2(mainApi, eventId, eligiblePlayerId);
        if (response.status !== 200) {
            dispatch(showErrorPopup({
                message: 'Error deleting Eligible Player',
                error: 'Please refresh the page and try again.',
            }));
            return;
        }
        dispatch({ type: EVENT_PROFILE_DELETE_ELIGIBLE_PLAYER_SUCCESS, payload: eligiblePlayerId });
        return true;
    } catch (e) {
        dispatch(showErrorPopup({
            message: 'Error deleting Eligible Player',
            error: e.response?.data?.DisplayMessage,
        }));
    }
};

export const sendPreRegistrationInvites = (eventId, data, successMessage) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.sendPreRegistrationInvitesV2(mainApi, eventId, data);
        if (res.status === 200) {
            if (!(res.data.invalidPlayerIds.length > 0 || res.data.unclaimedPlayers.length > 0 || res.data.invalidPlayersForDivisionCategoryGender.length > 0)) {
                dispatch(showSuccessToast({
                    title: 'Your Invitation Was Sent.',
                    message: successMessage,
                }));
            }
            return {
                success: true,
                data: res.data,
            };
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error sending pre-registration invites.',
            err,
        }));
    }
};

export const getPreRegistrationInviteList = (eventId, filters, sortData = {}, page = 1) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES });
    try {
        const res = await tmsEventsApi.getPreRegistrationInviteListV2(mainApi, eventId, page, filters, sortData);
        dispatch({ type: EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_PRE_REGISTRATION_INVITES_FAILURE });
        throw error;
    }
};

export const resendPreRegistrationInvite = (eventId, invteId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.resendPreRegistrationInviteV2(mainApi, eventId, invteId);
        if (res.status === 200) {
            return {
                success: true,
                data: res.data,
            };
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error resending pre-registration invite.',
            error: err.response?.data?.DisplayMessage,
        }));
    }
};

export const bulkResendPreRegistrationInvites = (eventId, data, queryData) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.bulkReSendPreRegistrationInvites(mainApi, eventId, data);
        if (res.status === 200) {
            dispatch(showSuccessToast({ message: 'Pre-registration invite(s) resent successfully.' }));
            await dispatch(getPreRegistrationInviteList(eventId, queryData.filters, queryData.sortData, queryData.currentPage));
        } else {
            dispatch(showErrorPopup({
                message: 'Error resending pre-registration invite(s).',
                error: res?.data?.DisplayMessage,
            }));
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error resending pre-registration invite(s).',
            error: err.response?.data?.DisplayMessage,
        }));
    }
};

export const bulkDeletePreRegistrationInvites = (eventId, data, queryData) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.bulkDeletePreRegistrationInvites(mainApi, eventId, data);
        if (res.status === 200) {
            dispatch(showSuccessToast({ message: 'Pre-registration invite(s) deleted successfully.' }));
            await dispatch(getPreRegInviteFilters(eventId));
            await dispatch(getPreRegistrationInviteList(eventId, queryData.filters, queryData.sortData, queryData.currentPage));
        } else {
            dispatch(showErrorPopup({
                message: 'Error deleting pre-registration invite(s).',
                error: res?.data?.DisplayMessage,
            }));
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error deleting pre-registration invite(s).',
            error: err.response?.data?.DisplayMessage,
        }));
    }
};

export const bulkExtendPreRegistrationInvites = (eventId, data, queryData) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.bulkExtendPreRegistrationInvites(mainApi, eventId, data);
        if (res.status === 200) {
            dispatch(showSuccessToast({ message: 'Pre-registration invite(s) extended successfully.' }));
            await dispatch(getPreRegInviteFilters(eventId));
            await dispatch(getPreRegistrationInviteList(eventId, queryData.filters, queryData.sortData, queryData.currentPage));
        } else {
            dispatch(showErrorPopup({
                message: 'Error extending pre-registration invite(s).',
                error: res?.data?.DisplayMessage,
            }));
        }
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error extending pre-registration invite(s).',
            error: err.response?.data?.DisplayMessage,
        }));
    }
};

export const getMemberIdsFromPreRegInvites = (eventId, data) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getMemberIdsFromPreRegInvites(mainApi, eventId, data);
        if (res.status === 200) {
            return res.data;
        }

        return [];
    } catch (err) {
        dispatch(showErrorPopup({
            message: 'Error sending message to selected players.',
            err,
        }));
    }
};

export const deletePreRegInvite = (eventId, inviteId) => async (dispatch, getState, { mainApi }) => {
    try {
        const response = await tmsEventsApi.removePreRegistrationInviteV2(mainApi, eventId, inviteId);
        if (response.status !== 200) {
            dispatch(showErrorPopup({
                message: 'Error deleting Pre-registration invite',
                error: 'Please refresh the page and try again.',
            }));
            return;
        }
        dispatch({ type: EVENT_PROFILE_DELETE_PRE_REGISTRATION_INVITE_SUCCESS, payload: inviteId });
        return true;
    } catch (e) {
        dispatch(showErrorPopup({
            message: 'Error deleting Pre-registration invite',
            error: e.response?.data?.DisplayMessage,
        }));
    }
};

export const getPreRegInviteFilters = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_PRE_REG_FILTERS });
    try {
        const res = await tmsEventsApi.getPreRegInviteFilters(mainApi, eventId);
        dispatch({ type: EVENT_PROFILE_GET_PRE_REG_FILTERS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_PRE_REG_FILTERS_FAILURE });
        throw error;
    }
};

export const getPreRegStats = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_PRE_REG_STATS });
    try {
        const res = await tmsEventsApi.getPreRegStats(mainApi, eventId);
        dispatch({ type: EVENT_PROFILE_GET_PRE_REG_STATS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_PRE_REG_STATS_FAILURE });
        throw error;
    }
};

export const declinePreRegInvitation = (eventId, inviteId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: 'SPLASH_SHOW_LOADING',
        });

        await tmsEventsApi.declinePreRegInvitationV2(mainApi, eventId, inviteId);
        dispatch({
            type: EVENT_PROFILE_REG_CLEAR_PRE_REG_INVITE,
            payload: {
                preRegistrationInviteId: inviteId,
            },
        });
        dispatch({
            type: 'SPLASH_HIDE',
        });
    } catch (err) {
        dispatch({
            type: 'SPLASH_HIDE',
        });
        dispatch(showErrorPopup({
            message: 'Error declining pre-registration invite.',
            err,
        }));
    }
};

export const getNextAvailablePublishedDraws = (eventId) => async (dispatch, getState, { mainApi }) => {
    try {
        dispatch({
            type: EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE,
            payload: {
                eventId,
            },
        });
        const res = await tmsEventsNextAvailableApi.getPublishedDraws(mainApi, eventId);
        dispatch({
            type: EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_SUCCESS,
            payload: {
                data: res.data,
                eventId,
            },
        });
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_NEXT_AVAILABLE_SCHEDULE_FAILURE,
            payload: {
                error: error.response?.data?.DisplayMessage,
                eventId,
            },
        });
    }
};

export const getNextAvailableLiveMatches = (
    eventId,
    selectedFacilityId,
    matchStatuses,
    showLoader = true,
    updateFacilitiesList = false,
) => async (dispatch, getState, { mainApi }) => {
    const { eventProfile, coreUI } = getState();
    const { draws, players, teams, liveMatches, locations } = eventProfile;
    const { playersDictByMemberId = {} } = players;
    const { teamsDict = {} } = teams;
    const { drawCategoryTypes = [] } = coreUI.types?.tms?.draw || {};
    const drawCategoryTypesDict = updateCategoryTypesName(createTypeByIdDict(drawCategoryTypes));

    try {
        dispatch({
            type: EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES,
            payload: {
                showLoader,
                matches: showLoader ? [] : liveMatches.matches,
            },
        });

        const selectedFacilities = selectedFacilityId ? [selectedFacilityId] : [];

        const res = await tmsEventsNextAvailableApi.getLiveMatches(mainApi, eventId, matchStatuses, selectedFacilities);

        const updatedDrawObjects = draws?.data?.map((parentDraw) => {
            const childDraws = getUpdatedChildDraws(parentDraw, drawCategoryTypesDict);
            return {
                ...parentDraw,
                childDraws,
                customDrawId: `parent-${parentDraw.id}`,
            };
        });

        const matches = res.data?.map((match) => {
            const updatedMatch = getUpdatedMatchObject(match, updatedDrawObjects, drawCategoryTypesDict);
            const position1Players = getPlayersListFromMatchPosition(updatedMatch.position1, playersDictByMemberId, teamsDict);
            const position2Players = getPlayersListFromMatchPosition(updatedMatch.position2, playersDictByMemberId, teamsDict);
            return {
                ...updatedMatch,
                position1Players,
                position2Players,
            };
        });

        const facilitiesEnabledForEvent = getActiveFacilitiesAndCourts(locations?.data);
        const uniqueFacilityIds = new Set(matches.map(match => match.drawClubLocationFacilityId));
        const facilitiesToDisplay = facilitiesEnabledForEvent.filter(facility => uniqueFacilityIds.has(facility.id));

        dispatch({
            type: EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_SUCCESS,
            payload: {
                matches,
                facilitiesAvailable: updateFacilitiesList ? facilitiesToDisplay : liveMatches.facilitiesAvailable,
            },
        });
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_NEXT_AVAILABLE_LIVE_MATCHES_FAILURE,
        });
    }
};

export const getPotentialPartners = (eventId, divisionId, memberId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.getPotentialPartners(mainApi, eventId, divisionId, memberId);
        if (res.status === 200) {
            return res.data;
        }
        dispatch(showErrorPopup({
            error: 'Error getting potential partners por player',
        }));
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error getting potential partners',
            error: error.response?.data?.DisplayMessage,
        }));
    }
};

export const getMedalPrintData = ({ eventId, drawId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_MEDALPRINT_DATA });

    try {
        const res = await tmsEventsApi.getMedalPrintData(mainApi, { eventId, drawId });
        dispatch({ type: EVENT_PROFILE_GET_MEDALPRINT_DATA_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_MEDALPRINT_DATA_FAILURE,
            payload: error,
        });
        throw error;
    }
};

export const getNeedsPartnerPlayers = ({ eventId, divisionId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS });
    try {
        const res = await tmsEventsApi.getNeedsPartnerPlayers(mainApi, { eventId, divisionId });
        dispatch({ type: EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({
            type: EVENT_PROFILE_GET_NEEDS_PARTNER_PLAYERS_FAILURE,
            payload: error,
        });
        throw error;
    }
};
export const getFacilities = ({ eventId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_FACILITIES });
    try {
        const res = await tmsEventsNextAvailableApi.getFacilities(mainApi, eventId);
        dispatch({ type: EVENT_PROFILE_GET_FACILITIES_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_FACILITIES_FAILURE });
        throw error;
    }
};

export const createPrintConfig = ({ eventId, clubLocationFacilityId, clubLocationFacilityName }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_CREATE_PRINT_CONFIG });
    try {
        const res = await tmsEventsNextAvailableApi.createPrintConfig(mainApi, eventId, clubLocationFacilityId, clubLocationFacilityName);
        dispatch({ type: EVENT_PROFILE_CREATE_PRINT_CONFIG_SUCCESS, payload: { operationQueueId: res?.data?.operationQueueId, clubLocationFacilityId } });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_CREATE_PRINT_CONFIG_FAILURE });
        throw error;
    }
};

export const postPrintTestPage = ({ eventId, clubLocationFacilityId, clubLocationFacilityName, operationQueueId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_PRINT_TEST_PAGE });
    try {
        await tmsEventsNextAvailableApi.postPrintTestPage(mainApi, eventId, clubLocationFacilityId, clubLocationFacilityName, operationQueueId);
        dispatch({ type: EVENT_PROFILE_PRINT_TEST_PAGE_SUCCESS });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_PRINT_TEST_PAGE_FAILURE });
        throw error;
    }
};

export const getRegisteredDoublesDivisions = ({ eventId }) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS });
    try {
        const res = await tmsEventsApi.getRegisteredDoublesDivisions(mainApi, eventId);
        dispatch({ type: EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_REGISTERED_DOUBLES_DIVISIONS_FAILURE });
        throw error;
    }
};
export const resetRegisteredDoublesDivisions = () => async (dispatch) => {
    dispatch({ type: EVENT_PROFILE_RESET_REGISTERED_DOUBLES_DIVISIONS });
};

export const updateRegistrationPartners = ({ eventId, payload }) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await tmsEventsApi.updateRegistrationPartners(mainApi, eventId, payload);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error updating registration partners',
                error: res.data.error,
            }));
        } else {
            // clear change partner update store
            dispatch(addChangePartnerUpdate({}));
            dispatch(showSuccessToast({ message: 'Registration update successful.' }));
            const currentEventId = getState().eventProfile.event.data?.id;
            if (currentEventId) {
                dispatch(getCurrentMemberRegistration(currentEventId));
            }
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error updating registration partners',
            error,
        }));
    }
};

function normalizeLiveScorePayload(liveScoreData) {
    const isLive = liveScoreData?.isLive;
    const periodScores = (liveScoreData.periodScores ?? []).slice();
    const gs = liveScoreData.gameState ?? liveScoreData.game_state;
    const gameState = gs
        ? {
            home_score: gs.home_score ?? gs.homeScore,
            away_score: gs.away_score ?? gs.awayScore,
            serving: gs.serving,
            advantage: gs.advantage,
        }
        : null;
    const liveMatch = {
        periodScores,
        gameState,
        position1: { isServing: liveScoreData.position1?.isServing === true },
        position2: { isServing: liveScoreData.position2?.isServing === true },
        matchDurationSeconds: liveScoreData.matchDurationSeconds,
        startTime: liveScoreData.startTime ?? null,
        status: liveScoreData.status ?? null,
    };
    const isSuspendedOrInterrupted =
        liveScoreData.status === 'suspended' ||
        liveScoreData.status === 'interrupted';
    const patch = {
        isLive,
        liveMatch: isLive || periodScores.length > 0 || isSuspendedOrInterrupted ? liveMatch : null,
    };
    if (!isLive && liveScoreData.result) {
        patch.result = {
            ...liveScoreData.result,
            score: liveScoreData.result.score,
            players: liveScoreData.result.players,
            completionType: liveScoreData.result.completionType,
            outcome: liveScoreData.result.outcome,
            date: liveScoreData.result.date || liveScoreData.result.resultDate,
        };
    }
    return patch;
}

export const refreshEndedScheduleMatch = (matchId) => async (dispatch, getState, { mainApi }) => {
    const state = getState().eventProfile;
    const eventId = state.event?.data?.id;
    if (!eventId) {
        return;
    }

    const oopMatches = state.orderOfPlaySchedule?.data?.matches ?? [];
    const oopItem = oopMatches.find((item) => (item.matchId || item.matchDetails?.id) === matchId);
    const oopDrawId = oopItem?.matchDetails?.drawId;

    const currentDrawRounds = state.currentDraw?.data?.rounds ?? [];
    const isInCurrentDraw = currentDrawRounds.some((round) => round.matches?.some((m) => m.id === matchId));
    const currentDrawId = isInCurrentDraw ? state.currentDraw.data.id : null;

    const drawId = oopDrawId || currentDrawId;
    if (!drawId) {
        return;
    }

    try {
        const res = await tmsEventsApi.getEventProfileMatch(mainApi, { eventId, drawId, matchId });
        if (oopItem) {
            dispatch({
                type: EVENT_PROFILE_OOP_MATCH_REFRESH_SUCCESS,
                payload: { matchId, matchDetails: res.data },
            });
        }
        if (isInCurrentDraw) {
            dispatch({
                type: EVENT_PROFILE_GET_MATCH_SUCCESS,
                payload: res.data,
            });
        }
    } catch (e) {
        console.error('Failed to refresh ended match', e);
    }
};

export const updateLiveScoreData = (liveScoreData) => async (dispatch, getState) => {
    if (!liveScoreData?.utrMatchId) {
        return;
    }
    const eventId = getState().eventProfile?.event?.data?.id;
    if (eventId != null && liveScoreData.utrEventId != null && Number(liveScoreData.utrEventId) !== Number(eventId)) {
        return;
    }
    const patch = normalizeLiveScorePayload(liveScoreData);
    const isSuspendedOrInterrupted =
        liveScoreData.status === 'suspended' ||
        liveScoreData.status === 'interrupted';
    const isMatchEnded = (liveScoreData.status === 'ended' || !liveScoreData.isLive) && !isSuspendedOrInterrupted;
    dispatch({
        type: EVENT_PROFILE_LIVE_SCORE_UPDATE,
        payload: {
            matchId: liveScoreData.utrMatchId,
            eventId: liveScoreData.utrEventId,
            patch,
            isMatchEnded,
        },
    });
    if (isMatchEnded) {
        dispatch(refreshEndedScheduleMatch(liveScoreData.utrMatchId));
    }
};

const MAX_ATTEMPTS = 6;
const POLL_INTERVAL = 10000;

export const pollRecurringEventCreated = (eventId) => async (dispatch, getState, { mainApi }) => {
    // Prevent duplicate polling per event
    if (recurringPollingMap[eventId]) {
        return;
    }

    let intervalId = null;
    let attempts = 0;
    let isStopped = false;

    const stop = () => {
        if (intervalId) {
            clearInterval(intervalId);
        }
        delete recurringPollingMap[eventId];
        isStopped = true;
    };

    const poll = async () => {
        if (isStopped) { return; }
        try {
            attempts += 1;
            const res = await tmsEventsApi.getRecurringEventsStatus(mainApi, eventId);

            if (res?.data?.isCreated) {
                stop();

                dispatch({
                    type: NOTIFICATIONS_SHOW_SUCCESS_TOAST,
                    title: 'Your Recurring Events Have Been Created',
                    message: 'Everything is set! The events are now available in your Club.',
                });
                // fetch recurring events
                dispatch(getUpcomingRecurringEvents(eventId));

                return;
            }

            if (attempts >= MAX_ATTEMPTS) {
                stop();

                dispatch({
                    type: NOTIFICATIONS_SHOW_INFO_TOAST,
                    title: 'Your Recurring Events Are Still Being Processed',
                    message: 'Please refresh your club page in a few minutes. Contact support if the events do not appear.',
                });
            }
        } catch (err) {
            // Recurring events polling failed
        }
    };

    // Set guard BEFORE any async work to avoid race conditions
    recurringPollingMap[eventId] = true;

    // Run immediately once
    await poll();

    // Start interval ONLY if still active
    if (!isStopped) {
        intervalId = setInterval(poll, POLL_INTERVAL);
        // Store intervalId so it can be cleared later
        recurringPollingMap[eventId] = intervalId;
    }
};

export const stopRecurringEventPolling = (eventId) => () => {
    const intervalId = recurringPollingMap[eventId];

    if (typeof intervalId === 'number') {
        clearInterval(intervalId);
    }
    delete recurringPollingMap[eventId];
};

export const stopAllRecurringEventPolling = () => () => {
    Object.keys(recurringPollingMap).forEach((eventId) => {
        const intervalId = recurringPollingMap[eventId];
        if (intervalId) {
            clearInterval(intervalId);
        }
        delete recurringPollingMap[eventId];
    });
};

export const getUpcomingRecurringEvents = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS });
    try {
        const res = await tmsEventsApi.getUpcomingRecurringEvents(mainApi, eventId);

        if (res?.data) {
            dispatch({
                type: EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_SUCCESS,
                payload: res.data,
            });
        }
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_UPCOMING_RECURRING_EVENTS_FAILURE });
    }
};

export const getDivisionCounts = (eventId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENT_PROFILE_GET_DIVISION_COUNTS });
    try {
        const res = await tmsEventsApi.getDivisionCounts(mainApi, { eventId });
        dispatch({ type: EVENT_PROFILE_GET_DIVISION_COUNTS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: EVENT_PROFILE_GET_DIVISION_COUNTS_FAILURE });
    }
};
